import { render, staticRenderFns } from "./FooterComponentBbw.vue?vue&type=template&id=de4b2958"
import script from "./FooterComponentBbw.vue?vue&type=script&lang=ts"
export * from "./FooterComponentBbw.vue?vue&type=script&lang=ts"
import style0 from "./FooterComponentBbw.vue?vue&type=style&index=0&id=de4b2958&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports